
exports.ById = {
  1: { Id: 1, Name: 'pli_value_type.gross_margin' },
  2: { Id: 2, Name: 'pli_value_type.berry_ratio' },
  3: { Id: 3, Name: 'pli_value_type.operating_margin' },
  4: { Id: 4, Name: 'pli_value_type.return_on_operating_assets' },
  5: { Id: 5, Name: 'pli_value_type.cost_plus' },
  6: { Id: 6, Name: 'pli_value_type.net_cost_plus' },
  7: { Id: 7, Name: 'pli_value_type.none' }
};

exports.ByName = {
  GrossMargin: { Id: 1, Name: 'pli_value_type.gross_margin' },
  BerryRatio: { Id: 2, Name: 'pli_value_type.berry_ratio' },
  OperatingMargin: { Id: 3, Name: 'pli_value_type.operating_margin' },
  ReturnOnOperatingAssets: { Id: 4, Name: 'pli_value_type.return_on_operating_assets' },
  CostPlus: { Id: 5, Name: 'pli_value_type.cost_plus' },
  NetCostPlus: { Id: 6, Name: 'pli_value_type.net_cost_plus' },
  None: { Id: 7, Name: 'pli_value_type.none' }
};
